import {API2_PULSE} from 'consts/api2'
import BaseStore from './base-store'
import StoreProxy from './store_proxy'
import Rest from 'utils/rest'

const LIMIT = 10

export class PulseItem extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      entity_name: undefined,
      entity_logo_url: undefined,
      category: undefined,
      created_at: undefined,
      changed_at: undefined,
      date: undefined,
      title: undefined,
      source_icon_urls: undefined,
      liked: 0,
      seen: undefined,
      favorite: false,
      entity_id: undefined,
      category_label: undefined,
      status: undefined,
      event_id: undefined,
      entity_type: undefined,
      parent_entity_logo_url: undefined,
      parent_entity_name: undefined,

      //extended fields
      sections: undefined,
      type: undefined,
      action: undefined,
      suggestions: undefined,
      feed_count: undefined,
      user_entity_id: undefined,

      semantic_skip: undefined,
      ...values
    }, {do_not_track: ['liked', 'semantic_skip']})
  }

  get modified_at() {
    return this.changed_at || this.created_at
  }

  get shared_company_id(){
    return this._state.entity_id
  }
  async doSave(_, changed){
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    await this._rest.patch(`${API2_PULSE}/${this._state.id}`, to_write)
  }
  async like(feedback) {
    const liked = this._state.liked == 1 ? 0 : 1
    await this._rest.patch(`${API2_PULSE}/${this._state.id}/like`, {liked, feedback})
    this._state.liked = liked
  }

  async dislike(feedback) {
    const liked = this._state.liked == -1 ? 0 : -1
    await this._rest.patch(`${API2_PULSE}/${this._state.id}/like`, {liked, feedback})
    this._state.liked = liked
  }

  async markSeen() {
    this._state.seen = true
    await this.save()
  }

  async doLoad(){
    const result = await this._rest.get(`${API2_PULSE}/${this._state.id}`)
    for (const key in this._state) {
      this._state[key] = result[key]
    }
  }

  setRest(rest){
    this._rest = rest
  }
}

export class Pulse extends BaseStore {
  constructor() {
    super({
      items: [],
      total: 0,
      categories_count: {},
      cache: new Map()
    })
  }

  async doLoad(rest, _params = {}) {
    const {semantic, ...params} = _params
    if (semantic) {
      await this.doLoadSemantic(rest, params)
    }
    else if (params.more) {
      const result = await (rest || this._rest).get(API2_PULSE, {before: this._state.items.at(-1).changed_at, limit: LIMIT, ...params})
      this._state.items.push(...result.items.map(data => this.createItem(data)))
    }
    else if (params.new) {
      const result = await (rest || this._rest).get(API2_PULSE, {after: this._state.items.at(0).changed_at, limit: LIMIT, ...params})
      const result_ids = new Set(result.items.map(x => x.id))
      this._state.items = this._state.items.filter(x => !result_ids.has(x.id))
      this._state.items.unshift(...result.items.map(data => this.createItem(data)))
      this._state.total = result.total
      this._state.categories_count = result.categories_count
    }
    else {
      const result = await (rest || this._rest).get(API2_PULSE, {limit: LIMIT, ...params})
      this._state.items = result.items.map(data => this.createItem(data))
      this._state.total = result.total
      this._state.categories_count = result.categories_count
    }
  }

  async doLoadSemantic(rest, params){
    // for semantic search backend can return items.length < LIMIT but we should
    // always increase skip by LIMIT, not by items.length
    this._state.semantic_skip = params.more ? this._state.semantic_skip + LIMIT : 0
    const result = await (rest || this._rest).get(API2_PULSE, {limit: LIMIT, skip: this._state.semantic_skip, ...params})
    const items = result.items.map(data => this.createItem(data))
  
        
    if (params.more) {
      this._state.items.push(...items)
    } else {
      this._state.items = items
    }

    const items_len = this._state.items.length
    const end = !result.has_more
    const total = end ? items_len : items_len + 1
    this._state.total = total
    this._state.categories_count = {semantic: total}
  }

  createItem(data){
    const item = this._state.cache.get(data.id)
    if (item) {
      Object.keys(data).forEach(key => item[key] = data[key])
      return item
    }
    else return new PulseItem(data)
  }

  getItem(id) {
    return this._state.cache.get(id) || this._state.items.find(x => x.id === id)
  }

  getByShCompany(id) {
    return this._state.items.find(x => x.shared_company_id === id)
  }

  removeItem(id) {
    const item = this.getItem(id)
    if (item) {
      this._state.items = this._state.items.filter(x => x.id !== id)
      this._state.categories_count[item.category] -= 1
      this._state.total -= 1
    }
  }

  clear(){
    this._state.items = []
    this._state.categories_count = {}
    this._state.total = 0
  }

  clearCache(){
    this._state.cache.clear()
  }

  abort(){
    this._rest.abortAll()
  }
  pinItem(id){
    if (this._state.cache.has(id)) return
    
    const item = this.getItem(id)

    if (item !== undefined) {
      this._state.cache.set(id, item)
    }
  }

  async loadSignal(id,rest){
    let item = this.getItem(id)
    if (!item) {
      item = new PulseItem({id})
      this._state.cache.set(id, item)
    }
    if (rest) {
      item.setRest(rest)
    }
    await item.markSeen()
    await item.load()
    return item
  }
}

const $pulse = new StoreProxy(new Pulse())

export function fetchItem(id){
  return new Rest().get(`${API2_PULSE}/${id}`)
}

export default $pulse
